import { motion } from "framer-motion";
import { fadeUp, stagger } from "./motion";
import { ASSETS } from "../../data/site";

const ITEMS = [
  { src: ASSETS.banner, alt: "Rolled ice cream flavors", cls: "col-span-2 sm:col-span-4 row-span-2" },
  { src: ASSETS.prep1, alt: "Ice cream rolling process", cls: "" },
  { src: ASSETS.mangonada, alt: "The Mangonada", cls: "" },
  { src: ASSETS.prep2, alt: "Fresh ingredients on the pan", cls: "" },
  { src: ASSETS.gulaabJamun, alt: "Go Gulaab Jamun rolls", cls: "" },
  { src: ASSETS.family1, alt: "Happy family enjoying dessert", cls: "col-span-2" },
  { src: ASSETS.rasMalai, alt: "Ras Malai rolls", cls: "" },
  { src: ASSETS.uniform, alt: "Our team, freshly uniformed", cls: "" },
  { src: ASSETS.faloodaFantasy, alt: "Falooda Fantasy", cls: "" },
  { src: ASSETS.shakesCups, alt: "Premium handcrafted shakes", cls: "" },
];

export const Gallery = () => {
  return (
    <section id="gallery" data-testid="gallery-section" className="relative bg-[#FFF7F0]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 sm:py-28">
        <div className="text-center mb-12">
          <motion.span variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }}
            className="eyebrow text-[#12B99B]">The Gallery</motion.span>
          <motion.h2 variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }}
            className="font-display mt-3 text-[clamp(2rem,5vw,3.75rem)] leading-[1.02] text-[#2A1620]">
            Rolled to <span className="font-script text-[#F63C8B]">perfection</span>
          </motion.h2>
        </div>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }}
          className="grid grid-cols-2 sm:grid-cols-4 auto-rows-[140px] sm:auto-rows-[230px] gap-3 sm:gap-4">
          {ITEMS.map((it, i) => (
            <motion.figure key={i} variants={fadeUp} data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden rounded-3xl border-4 border-white shadow-[0_20px_40px_-24px_rgba(246,60,139,0.5)] ${it.cls}`}>
              <img src={it.src} alt={it.alt} loading="lazy"
                className="w-full h-full object-cover transition-transform duration-[1000ms] ease-out group-hover:scale-110" />
              <figcaption className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 bg-white/90 backdrop-blur px-3 py-2 text-[11px] font-bold uppercase tracking-[0.12em] text-[#F63C8B]">
                {it.alt}
              </figcaption>
            </motion.figure>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
